/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MultiBarChartData } from './MultiBarChartData';
import {
    MultiBarChartDataFromJSON,
    MultiBarChartDataFromJSONTyped,
    MultiBarChartDataToJSON,
} from './MultiBarChartData';

/**
 * 
 * @export
 * @interface GetCompletedOrFailedJobsChartData200Response
 */
export interface GetCompletedOrFailedJobsChartData200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetCompletedOrFailedJobsChartData200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCompletedOrFailedJobsChartData200Response
     */
    error: string;
    /**
     * 
     * @type {MultiBarChartData}
     * @memberof GetCompletedOrFailedJobsChartData200Response
     */
    data: MultiBarChartData;
}

/**
 * Check if a given object implements the GetCompletedOrFailedJobsChartData200Response interface.
 */
export function instanceOfGetCompletedOrFailedJobsChartData200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCompletedOrFailedJobsChartData200ResponseFromJSON(json: any): GetCompletedOrFailedJobsChartData200Response {
    return GetCompletedOrFailedJobsChartData200ResponseFromJSONTyped(json, false);
}

export function GetCompletedOrFailedJobsChartData200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompletedOrFailedJobsChartData200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': MultiBarChartDataFromJSON(json['data']),
    };
}

export function GetCompletedOrFailedJobsChartData200ResponseToJSON(value?: GetCompletedOrFailedJobsChartData200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': MultiBarChartDataToJSON(value.data),
    };
}

